
export const major = Uint8Array.of(0,2,4,5,7,9,11);
